import { render, staticRenderFns } from "./accountManage.vue?vue&type=template&id=058fb380&scoped=true&"
import script from "./accountManage.vue?vue&type=script&lang=js&"
export * from "./accountManage.vue?vue&type=script&lang=js&"
import style0 from "./accountManage.vue?vue&type=style&index=0&id=058fb380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058fb380",
  null
  
)

export default component.exports